<div class="main-container">
  <div class="main-message-container-content">
    <a [href]="sureRouteUrl" target="_blank" rel="noopener noreferrer">
      <h3>Sure Route</h3>
    </a>
  </div>
</div>
